import * as React from 'react';
export const Checklist = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M4.26 20.608L0 16.327l1.26-1.267 3 2.985 5.37-5.397 1.26 1.297-6.63 6.663zm0-9.648L0 6.678l1.26-1.266 3 2.985L9.63 3l1.26 1.296-6.63 6.664zm8.94 7.357v-1.81H24v1.81H13.2zm0-9.649V6.86H24v1.81H13.2z" />
  </svg>
);
